import React from "react";
import PropTypes from "prop-types";
import Str from "shared/components/Str";

import "apps/messenger/components/Connections/shared/Compatibilities.scss";

function Compatibilities({ children }) {
	return (
		<div className="connection-compatibilities">
			<div
				className="connection-compatibilities-header"
			>
				<Str>About them</Str>
			</div>
			{
				children
					.sort((a, b) => a.priority - b.priority)
					.slice(0, 3)
					.map(({
						description,
						type,
						subtype,
						icon,
					}) => (
						<div
							className="connection-compatibilities-compatibility"
							key={`${type}-${subtype}`}
						>
							<div
								className="connection-compatibilities-compatibility-icon"
								style={{
									backgroundImage: `url(${icon})`,

								}}
							/>
							{description}
						</div>
					))
			}
		</div>
	);
}

Compatibilities.propTypes = {
	children: PropTypes.arrayOf(
		PropTypes.shape({
			description: PropTypes.string.isRequired,
			type: PropTypes.string.isRequired,
			subtype: PropTypes.string,
		}),
	).isRequired,
};

export default Compatibilities;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/Connections/shared/Compatibilities.jsx